/* Function check mobile device */
function IsMobile() {
  var Uagent = navigator.userAgent||navigator.vendor||window.opera;
  return(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(Uagent)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(Uagent.substr(0,4))); 
};

/* Sticky Header */
jQuery(document).ready(function($) {

  if (IsMobile()){

    if ($(".js-sticky-show").length) {
      $(".engojs-change-sticky-mobile").removeClass( "js-sticky-show");
      $(".engojs-change-sticky-mobile").addClass("js-sticky-show-mobile");
    }

    var $filterMobile = $('.js-sticky-show-mobile');
    var $filterSpacer = $('<div />', {
      "class": "nguyenhuuphuc-ptit-mobile",
      "height": $filterMobile.outerHeight()
    });

    if ($filterMobile.size()){
      $(window).scroll(function (){
        if (!$filterMobile.hasClass('fixed-header') && $(window).scrollTop() > $filterMobile.offset().top){
          $filterMobile.before($filterSpacer);
          $filterMobile.addClass("fixed-header");
        }
        else if ($filterMobile.hasClass('fixed-header')  && $(window).scrollTop() < $filterSpacer.offset().top){
          $filterMobile.removeClass("fixed-header");
          $filterSpacer.remove();
        }
      });
    }

  } else {

    var $filter = $('.js-sticky-show');
    var $filterSpacer = $('<div />', {
      "class": "nguyenhuuphuc-ptit",
      "height": $filter.outerHeight()
    });

    if ($filter.size()){
      $(window).scroll(function (){
        if (!$filter.hasClass('fixed-header') && $(window).scrollTop() > $filter.offset().top){
          $filter.before($filterSpacer);
          $filter.addClass("fixed-header");
        }
        else if ($filter.hasClass('fixed-header')  && $(window).scrollTop() < $filterSpacer.offset().top){
          $filter.removeClass("fixed-header");
          $filterSpacer.remove();
        }
      });
    }

  }


  function jsRelateProduct(){
    $('.js_relate_product').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 2,
      dots: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
      arrows: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
          }
        }
      ]
    });
  }

  jsRelateProduct()      

});

jQuery(document).ready(function($) {
  "use strict";
  function slideshowV1(){
    $('.js-slideshow-v1').slick({
      dots: true,
      arrows: false,
      autoplay:false,
      fade:true,
      adaptiveHeight: true
    }); 


    $('.js-slideshow-v1 .slick-current .slider-v1 .img-slide').addClass('active')
    $('.js-slideshow-v1 .slick-current .slider-v1 .slide-info').addClass('active')
    $('.js-slideshow-v1').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = mySlideNumber - 1;
      console.log(mySlideNumber);
      console.log(prev)
      $('.js-slideshow-v1 .slider-v1 .img-slide').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v1 .slider-v1 .slide-info').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v1 .slider-v1 .img-slide').eq(prev).removeClass('active');
      $('.js-slideshow-v1 .slider-v1 .slide-info').eq(prev).removeClass('active');
    });

  }


  function blogV1() {
    $('.js-slider-blog-v1').slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay:false,
      speed: 500,
      slidesToScroll: 2,
      slidesToShow: 3,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: false
          }
        }
      ]
    });
  }

  function slideshowV2(){
    $('.js-slideshow-v2').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true
    });
    $('.js-slideshow-v2 .item-slider').eq(0).addClass('active')
    $('.js-slideshow-v2 .slide-info').eq(0).addClass('active')
    $('.js-slideshow-v2').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = mySlideNumber - 1;
      $('.js-slideshow-v2 .item-slider').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v2 .slide-info').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v2 .item-slider').eq(prev).removeClass('active');
      $('.js-slideshow-v2 .slide-info').eq(prev).removeClass('active');
    });
  }

  function slideshowV3(){
    $('.js-slideshow-v3').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true
    });
    $('.js-slideshow-v3 .item-slider').eq(0).addClass('active')
    $('.js-slideshow-v3 .slide-info').eq(0).addClass('active')
    $('.js-slideshow-v3').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = mySlideNumber - 1;
      $('.js-slideshow-v3 .item-slider').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v3 .slide-info').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v3 .item-slider').eq(prev).removeClass('active');
      $('.js-slideshow-v3 .slide-info').eq(prev).removeClass('active');
    });
  }

  function productV3() {
    $('.js-product-v3').slick({
      arrows: true,
      dots: true,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            dots: false,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: false
          }
        }
      ]
    });
  }

  function countdownProductV1() {
    $('.js-mid').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: true,
      infinite: false,
      asNavFor: '.js-product-thumbnail'
    });
    $('.js-product-thumbnail').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      asNavFor: '.js-mid',
      dots: false,
      arrows: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1215,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false
          }
        }
      ]
    });
  }

  function testimonialV1() {
    $('.js-testimonial-v1').slick({
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
          }
        }
      ]
    });
  }

  function slideshowV4() {
    $('.js-slideshow-v4').slick({
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
          }
        }
      ]
    });
  }

  function jsbrandV1() {
    $('.js-brand-v1').slick({
      dots: false,
      arrows:true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="ti-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="ti-angle-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            autoplay: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            autoplay: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            autoplay: true,
            dots: true
          }
        }
      ]
    });
  }

  slideshowV1();
  blogV1();
  slideshowV2();
  slideshowV3();
  productV3();
  countdownProductV1();
  testimonialV1();
  slideshowV4();
  jsbrandV1();
});


jQuery(document).ready(function($) {
  "use strict";
  function video() {
    $('[data-fancybox]').fancybox({
      youtube : {
        controls : 0,
        showinfo : 0
      },
      vimeo : {
        color : 'f00'
      }
    });
  } 
  //setheight
  function setheightbannner6() {  
    $('.js_content_baner_h6').css({'height': function(){
      return $('.js_images').outerHeight(true);
    }})
    $(window).resize(function(){
      $('.js_content_baner_h6').css({'height': function(){
        return $('.js_images').outerHeight(true);
      }})
    });
  }
   function setheightbannner8(){
    $('.js_content_baner_h8').css({'height': function(){
      return $('.js_images8').outerHeight(true);
    }})
    $(window).resize(function(){
      $('.js_content_baner_h8').css({'height': function(){
        return $('.js_images8').outerHeight(true);
      }})
    });
     $('.js_content_baner_h82').css({'height': function(){
      return $('.js_images82').outerHeight(true);
    }})
    $(window).resize(function(){
      $('.js_content_baner_h82').css({'height': function(){
        return $('.js_images82').outerHeight(true);
      }})
    });
  }
  function setheighblog5() {
    $('.js_content_blog_h5').css({'height': function(){
      return $('.js_image_blog_h5').outerHeight(true);
    }})
    $(window).resize(function(){
      $('.js_content_blog_h5').css({'height': function(){
        return $('.js_image_blog_h5').outerHeight(true);
      }})
    });
  }
  function producth6(){
    $('.slick_product_featured_h6').slick({
      arrows: true,
      dots: true ,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows: false,
            slidesToScroll: 1,
            dots: false 
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            arrows: true,
            slidesToScroll: 1,
            dots: false 
          }
        }
      ]
    });
  }
  function producth5(){
    $('.slick_product_featured_h5').slick({
      arrows: true,
      dots: true ,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            arrows: false,

          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            arrows: false,

          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows: false,
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            arrows: true,
            dots: false ,
          }
        }
      ]
    });
  }
  function productbanerh8(){
    $('.slick_productandbaner_h8').slick({
      arrows: false,
      infinite: false,
      speed: 300,
      dots: false ,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        }
      ]
    });
  }
  
  function producth8(){
    $('.slick_product_h8').slick({
      arrows: true,
      speed: 300,
      dots: false ,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        }
      ]
    });
  }
  
  function productnewh6(){
    $('.slick_product_new-h6').slick({
      arrows: true,
      infinite: false,
      dots: true ,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        }
      ]
    });
  }
  function blogv1h5(){
    $('.js_slider_blogv1_h5').slick({
      arrows: true,
      infinite: false,
      speed: 300,
      dots: true ,
      slidesToShow: 2,
      slidesToScroll: 2,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 2,
            arrows: false,

          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            arrows: false,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            arrows: false,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            arrows: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            arrows: false,
          }
        }
      ]
    });
  }
  function testimonialsh6(){
    $('.list_testimonials-v1-h6').slick({
      arrows:true,
      dots: false ,
      autoplay:true,
      infinite: false,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="ti-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="ti-angle-right"></i></button>', 
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,

          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
          }
        }
      ]
    });
  }
  function testimonialsh7(){
    $('.list_testimonials-v1-h7').slick({
      arrows:true,
      dots: true ,
      infinite: false,
      autoplay:true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide"><i class="ti-angle-left" ></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="ti-angle-right" ></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,

          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
          }
        }
      ]
    });
  }
  function servicesh7(){
    $('.slickjs-services-h7').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 3,
      slidesToScroll: 1, 
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false ,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000
          }
        }
      ]
    });

  }
  function slidehome5(){
    $('.slick-side-h5').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
      dots: true,
      arrows: true,
      fade: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="ti-angle-left" ></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="ti-angle-right" ></i></button>', 
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3500
          }
        }
      ]
    });
  }
  function slidehome6(){
    $('.slick-side-h6').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
      dots: true,
      arrows: false,
      fade: true,
      customPaging: function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a>' + (i + 1) + '</a>';
      },
    });
  }  
  function slidehome7(){
    $('.slick-side-h7').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      //       autoplay: true,
      //       autoplaySpeed: 4500,
      dots: true,
      arrows: true,
      fade: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3500
          }
        }
      ]
    });
  }
  function slidehome8(){
    $('.slick-side-h8').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
      dots: true,
      arrows: false,
      fade: true
    });
  }
  function menuhome5() {
    $('.jsmenu_destop_home5').on('click', function() {
      $('.main-header-menu').addClass('active');
      $('.close-menu').addClass('active');
    });
    $('.js_closemenu_home5').on('click', function() {
      $('.main-header-menu').removeClass('active');
      $('.close-menu').removeClass('active');
    }); 

  }
  function menuhome7() {
    $('.jsmenu_destop_home7').on('click', function() {
      $('.horizon-menu-home7').addClass('active');                
    });
    $('.js_close-menu-horizon').on('click', function() {
      $('.horizon-menu-home7').removeClass('active');
    }); 

  }
  function jsmenuiconh7(){
    $('.js_icon_horizon-menu-home7').on( 'click', function() {
      $(this).toggleClass('active');
    });
  }
  function menuscrollh7() {
    var $nav = $(".js_header-home7");
    $nav.removeClass('menuscroll_home7');

    $(document).scroll(function() {

      $nav.toggleClass('menuscroll_home7', $(this).scrollTop() > $nav.height());
    });
  }
  menuscrollh7();
  menuhome7();
  jsmenuiconh7();
  menuhome5();
  video();
  setheightbannner6();
  setheightbannner8();
  setheighblog5();
  producth6();
  producth5();
  productbanerh8();
  producth8();
  productnewh6();
  blogv1h5();
  testimonialsh6();
  testimonialsh7();
  servicesh7();
  slidehome5();
  slidehome6();
  slidehome7();
  slidehome8();

});


jQuery(document).ready(function($){
  "use strict";
  
  function jsProductv2(){
    $('.js_duong_product_v2').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 2,
      dots: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
	  arrows: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false,
          }
        },
 

      ]
    });
  }
        
        function jsBlogv1(){
        $('.js_duong_blog_v1').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [
        {
        breakpoint: 1200,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrow: false,
        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        }
        },


      ]
    });
  }      

 		 function jsCatev1(){
    $('.js_duong_category_v1').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
      arrows: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrow: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          }
        },


      ]
        });
        }  

        function jsServicev1(){
        $('.js_duong_service_v1').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
        nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
        arrows: false,
        responsive: [
        {
        breakpoint: 1200,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrow: false,
        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        }
        },


      ]
    });
           $('.js_duong_service_v1').find('.slick-active').eq(0).addClass('itemtservicebefore')
           $('.js_duong_service_v1').find('.slick-active').eq(1).addClass('itemtservicebefore')
           $('.js_duong_service_v1').on('afterChange', function (event, slick, currentSlide, nextSlide) {
             var mySlideNumber = nextSlide;
             var a = mySlideNumber + 1;
             var b = mySlideNumber + 1;
             $('.js_duong_service_v1').find('.slick-active').eq(0).next().addClass('itemtservicebefore')
             $('.js_duong_service_v1').find('.slick-active').eq(0).prev().removeClass('itemtservicebefore')

           });
  }  

  function jsCatev2(){
    $('.js_duong_category_v2').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      dots: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
      arrows: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrow: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          }
        },


      ]
        });
        }  
  
	function jsProductv4(){
        $('.js_duong_product_v4').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
        nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
        arrows: true,
        responsive: [
        {
        breakpoint: 1200,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrow: true,
        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        }
        },


      ]
    });
  }  
        
 function jsBlogv2(){
        $('.js_duong_blog_v2').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        dots: true,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i> </button>',
        nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
        arrows: true,
        responsive: [
        {
        breakpoint: 1200,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrow: false,
        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        }
        },


      ]
    });
  }  
    

          function jsSlidev1(){
          

              $('.js_duong_slide_show_v1').slick({
              dots: true,
              arrows: false,
              autoplay: false,
              autoplaySpeed: 5000,
              fade: true,
              infinite: true,
              adaptiveHeight: true,
//               customPaging : function(slider, i) {
//               var thumb = $(slider.$slides[i]).data();
//               return '<a>'+(i+1)+'</a>';
//             },
          
              responsive: [
              {
              breakpoint: 1200,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrow: false,
              }
              },
              {
              breakpoint: 600,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              }
              },


            ]
          
              });
   
   			       
          
              $('.js_duong_slide_show_v1 .bg-slideshow .img_slide').eq(0).addClass('active')
              $('.js_duong_slide_show_v1 .bg-slideshow .slide-info').eq(0).addClass('active')
              $('.js_duong_slide_show_v1').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              var mySlideNumber = nextSlide;
              var prev = mySlideNumber - 1;
              $('.js_duong_slide_show_v1 .bg-slideshow .img_slide').eq(mySlideNumber).addClass('active');
              $('.js_duong_slide_show_v1 .bg-slideshow .slide-info').eq(mySlideNumber).addClass('active');
              $('.js_duong_slide_show_v1 .bg-slideshow .img_slide').eq(prev).removeClass('active');
              $('.js_duong_slide_show_v1 .bg-slideshow .slide-info').eq(prev).removeClass('active');
              });
          }  
  
  
            var $status = $('.pagingInfo');
            var $slickElement = $('.js_duong_slide_show_v1');
            $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
              var i = (currentSlide ? currentSlide : 0) + 1;
              $status.html('0' + i + '<p class="mb-0">/0' + slick.slideCount + '</p>');
            });
            $('.js_duong_slide_show_v1').on('afterChange', function(event, slick, currentSlide) {
              $('.slick-active').append('<div class="pagingInfo"');
            });

  			function jsSlidev2(){


              $('.js_duong_slide_show_v2').slick({
              dots: true,
              arrows: false,
              autoplay: false,
              autoplaySpeed: 5000,
              fade: true,
              infinite: true,
              adaptiveHeight: true,
              responsive: [
              {
              breakpoint: 1200,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrow: false,
              }
              },
              {
              breakpoint: 600,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              }
              },


            ]
          
              });
          
          
              $('.js_duong_slide_show_v2 .bg-slideshow .img_slide').eq(0).addClass('active')
              $('.js_duong_slide_show_v2 .bg-slideshow .slide-info').eq(0).addClass('active')
              $('.js_duong_slide_show_v2').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              var mySlideNumber = nextSlide;
              var prev = mySlideNumber - 1;
              $('.js_duong_slide_show_v2 .bg-slideshow .img_slide').eq(mySlideNumber).addClass('active');
              $('.js_duong_slide_show_v2 .bg-slideshow .slide-info').eq(mySlideNumber).addClass('active');
              $('.js_duong_slide_show_v2 .bg-slideshow .img_slide').eq(prev).removeClass('active');
              $('.js_duong_slide_show_v2 .bg-slideshow .slide-info').eq(prev).removeClass('active');
              });
          }  
                
                function jsSlidev3(){


              $('.js_duong_slide_show_v3').slick({
              dots: true,
              arrows: false,
              autoplay: false,
              autoplaySpeed: 5000,
              fade: true,
              infinite: true,
              adaptiveHeight: true,
              responsive: [
              {
              breakpoint: 1200,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrow: false,
              }
              },
              {
              breakpoint: 600,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              }
              },


            ]
          
              });
          
          
              $('.js_duong_slide_show_v3 .bg-slideshow .img_slide').eq(0).addClass('active')
              $('.js_duong_slide_show_v3 .bg-slideshow .slide-info').eq(0).addClass('active')
              $('.js_duong_slide_show_v3').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              var mySlideNumber = nextSlide;
              var prev = mySlideNumber - 1;
              $('.js_duong_slide_show_v3 .bg-slideshow .img_slide').eq(mySlideNumber).addClass('active');
              $('.js_duong_slide_show_v3 .bg-slideshow .slide-info').eq(mySlideNumber).addClass('active');
              $('.js_duong_slide_show_v3 .bg-slideshow .img_slide').eq(prev).removeClass('active');
              $('.js_duong_slide_show_v3 .bg-slideshow .slide-info').eq(prev).removeClass('active');
              });
          }  
          
  
  function jsSlideThuyv2(){


    $('.js_thuy_slide_show_v2').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrow: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
          }
        },


      ]

        });


        $('.js_thuy_slide_show_v2 .bg-slideshow .img_slide').eq(0).addClass('active')
        $('.js_thuy_slide_show_v2 .bg-slideshow .slide-info').eq(0).addClass('active')
        $('.js_thuy_slide_show_v2').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
        var prev = mySlideNumber - 1;
        $('.js_thuy_slide_show_v2 .bg-slideshow .img_slide').eq(mySlideNumber).addClass('active');
        $('.js_thuy_slide_show_v2 .bg-slideshow .slide-info').eq(mySlideNumber).addClass('active');
        $('.js_thuy_slide_show_v2 .bg-slideshow .img_slide').eq(prev).removeClass('active');
        $('.js_thuy_slide_show_v2 .bg-slideshow .slide-info').eq(prev).removeClass('active');
        });
        } 
        
        jsProductv2();
        jsBlogv1();
        jsCatev1();
  		 jsServicev1();
        jsCatev2();
  		 jsProductv4();
          jsBlogv2();
          jsSlidev1();
  			jsSlidev2();
  			jsSlidev3();
        jsSlideThuyv2()
  		

  
});